module.exports = __webpack_public_path__ + "static/img/iphone_5.41528ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_5.png
// module id = 1CfD
// module chunks = 0